import { Button } from '@hai/ui-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { apiClientWithoutHandler } from 'src/js/api';
import { APIPath } from 'src/js/api/route-path-index';
import { useModalControls } from 'src/js/hook/use-modal-controls';
import { SettingsTabContent } from 'src/js/pages/settings/settings-tab-content';
import useSWR from 'swr';

import { StillImage } from './still-image-model';
import { StillImageImportModal } from './stillimage-import-modal';
import { StillImagesList } from './stillimages-list';

export const StillImages: React.FunctionComponent = () => {
  const { t } = useTranslation();

  const [importShown, showImport, hideImport] = useModalControls();

  const fetcher = (url: string) => {
    return apiClientWithoutHandler.genericController.get(url).then((res: any) => {
      return res?.data?.data;
    });
  };

  const { data, mutate } = useSWR(APIPath.stillimages.list, fetcher, { revalidateOnFocus: false });
  const shouldReloadData = (): void => {
    mutate(data);
  };

  const afterImport = () => {
    shouldReloadData();
    hideImport();
  };

  return (
    <SettingsTabContent name={t('settings.stillImages.title')}>
      <div id="stillimages">
        <div className="buttonRow">
          <Button variant="secondary" onClick={showImport}>
            {t('general.import')}
          </Button>
        </div>
        <StillImagesList viewModels={data} shouldReloadData={shouldReloadData} />
        {importShown && (
          <StillImageImportModal
            onCancel={hideImport}
            afterImport={afterImport}
            listOfUsedNames={data.map((viewModel: StillImage) => viewModel.name)}
          />
        )}
      </div>
    </SettingsTabContent>
  );
};
